import template from './template.html'

angular.module('contabilidad.reportenominasmovimientos')
  .component('contabilidadReportenominasmovimientosLista', {
    controller: ContabilidadReportenominasmovimientosListaComponent,
    template,
    bindings: {
      data: '<',
    },
  })

function ContabilidadReportenominasmovimientosListaComponent ($document) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.copiar = copiar

  $ctrl.exportando = false

  function $onInit () {
    $ctrl.copiable = $document[0].queryCommandSupported('copy')
  }

  function copiar () {
    var elemento = $document[0].getElementById('contabilidad.reportenominasmovimientos.lista.texto')
    elemento.focus()
    elemento.select()
    document.execCommand('copy')
  }
}



// WEBPACK FOOTER //
// ./src/contabilidad/reportenominasmovimientos/components/lista/component.js